import React from 'react';
import {
  createSearchParams,
  Link,
  LinkProps,
  useSearchParams,
} from 'react-router-dom';

type Props = Omit<LinkProps, 'to'>;

export default function UndirectLink(props: Props) {
  const {children, ...rest} = props;
  const [params] = useSearchParams();
  const page = params.get('page');
  return (
    <Link
      to={page ? `?${createSearchParams(params).toString()}` : `/`}
      {...rest}
    >
      {children}
    </Link>
  );
}
